import { HeadingAttrs, TextSemanticLevel } from 'ui/theme/typographyAttrs/types'

export const setTextSemantic = (level: TextSemanticLevel): HeadingAttrs => ({
  accessibilityRole: undefined,
  accessibilityLevel: level,
})
